export default "__VITE_ASSET__Bo2G0IVQ__"